import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import WpDynamicTable from "../../Components/WhatsappTable/WpDynamicTable";
import {
    EInvoice_EWaySetupDetail_add,
    EInvoice_EWaySetupDetail_Update,
    EInvoice_EWaySetupDetail_Delete,
    fetchEInvoiceEWaySetupDetail,
    fetchEInvoiceEWaySetupMainData
} from "../../Redux/Einvoice&EwayBillSlice/Einvoice&EwayBill";
import Loader from "../../Components/Loader/Loader";

const Einvoice_Eway_Setup_Detail = () => {
    const dispatch = useDispatch();

    const { 
        EInvoiceEWaySetupDetailData, 
        EInvoiceEWaySetupDetailLoading,
        EInvoiceEWaySetupMainData 
    } = useSelector((state) => state.EinvoiceEwayBill);

    const [formData, setFormData] = useState({
        Provider: "",
        BillType: "",
        ApiType: "",
        Apis: "",
        ApiMethod: "",
    });

    useEffect(() => {
        dispatch(fetchEInvoiceEWaySetupMainData());
        dispatch(fetchEInvoiceEWaySetupDetail());
    }, [dispatch]);

    const [editId, setEditId] = useState(null);
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const validate = (formData) => {
        const errors = {};

        if (!formData.Provider || formData.Provider.trim() === "") {
            errors.Provider = "Provider is required";
        }

        if (!formData.BillType || formData.BillType.trim() === "") {
            errors.BillType = "Bill Type is required";
        }

        if (!formData.ApiType || formData.ApiType.trim() === "") {
            errors.ApiType = "Api Type is required";
        }

        if (!formData.Apis || formData.Apis.trim() === "") {
            errors.Apis = "Apis is required";
        }

        if (!formData.ApiMethod || formData.ApiMethod.trim() === "") {
            errors.ApiMethod = "API Method is required";
        }

        return errors;
    };

    const handleEdit = (row) => {
        setEditId(row.DetailId);
        setFormData({
            Provider: row.Provider, // Reference ID
            BillType: row.BillType,
            ApiType: row.ApiType,
            Apis: row.Apis,
            ApiMethod: row.ApiMethod,
        });
    };

    const handleDelete = async (row) => {
        const isConfirmed = window.confirm(
            `Are you sure you want to delete this detail setup?`
        );
        if (!isConfirmed) return;

        try {
            await dispatch(EInvoice_EWaySetupDetail_Delete({ id: row.DetailId })).unwrap();
            toast.success("Data deleted successfully!", {
                position: "top-right",
                autoClose: 1000,
            });
            dispatch(fetchEInvoiceEWaySetupDetail());
        } catch (error) {
            toast.error(`Failed to delete Data: ${error}`, {
                position: "top-right",
                autoClose: 1000,
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate(formData);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        if (Object.keys(validationErrors).length === 0) {
            try {
                if (editId) {
                    await dispatch(EInvoice_EWaySetupDetail_Update({ id: editId, formData })).unwrap();
                    toast.success("Einvoice/Eway Setup Detail updated successfully!", {
                        position: "top-right",
                        autoClose: 1000,
                    });
                } else {
                    await dispatch(EInvoice_EWaySetupDetail_add({ values: formData })).unwrap();
                    toast.success("Einvoice/Eway Setup Detail added successfully!!", {
                        position: "top-right",
                        autoClose: 1000,
                    });
                }

                // Reset form
                setFormData({
                    Provider: "",
                    BillType: "",
                    ApiType: "",
                    Apis: "",
                    ApiMethod: "",
                });
                setEditId(null);
                setErrors({});
                dispatch(fetchEInvoiceEWaySetupDetail());
            } catch (error) {
                toast.error(
                    `Failed to ${editId ? "update" : "add"} Data: ${error.message || "Unknown error"
                    }`,
                    {
                        position: "top-right",
                        autoClose: 1000,
                    }
                );
            }
        }
    };

    const columns = [
        { field: "id", headerName: "No", flex: 0.3, minWidth: 50 },
        { field: "ProviderName", headerName: "Provider", flex: 0.7, minWidth: 100 },
        { field: "BillType", headerName: "Bill Type", flex: 0.7, minWidth: 100 },
        { field: "ApiType", headerName: "Api Type", flex: 1.5, minWidth: 200 },
        { field: "Apis", headerName: "Apis", flex: 4, minWidth: 400 },
        { field: "ApiMethod", headerName: "Api Method", flex: 0.8, minWidth: 100 },
        {
            field: "actions",
            headerName: "Actions",
            flex: 1.2,
            minWidth: 160,
            renderCell: (params) => (
                <div className="flex space-x-2 justify-center">
                    <button
                        className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                        onClick={() => handleEdit(params.row)}
                    >
                        Update
                    </button>
                    <button
                        className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                        onClick={() => handleDelete(params.row)}
                    >
                        Delete
                    </button>
                </div>
            ),
        },
    ];

    const rows = Array.isArray(EInvoiceEWaySetupDetailData) ? EInvoiceEWaySetupDetailData.map((el, index) => ({
        id: index + 1,
        DetailId: el._id,
        Provider: el?.Provider?._id || el?.Provider,
        ProviderName: el?.Provider?.ProviderName || "--",
        BillType: el?.BillType,
        ApiType: el?.ApiType,
        Apis: el?.Apis,
        ApiMethod: el?.ApiMethod,
    })) : [];

    const ParentProviders = Array.isArray(EInvoiceEWaySetupMainData) ? EInvoiceEWaySetupMainData : [];

    if (EInvoiceEWaySetupDetailLoading && !EInvoiceEWaySetupDetailData?.length) {
        return <Loader />;
    }

    return (
        <>
            <div className="">
                <div className="title">
                    <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
                        {editId ? "Update E-invoice & E-way Setup Detail" : "Add E-invoice & E-way Setup Detail"}
                    </h3>
                </div>

                <div className="Form_bg_color bg-white shadow-sm rounded-xl mt-4">
                    <form
                        onSubmit={handleSubmit}
                        className="grid grid-cols-12 gap-4 p-3 rounded-2xl"
                    >
                        {/* Provider Dropdown */}
                        <div className="col-span-12 lg:col-span-4 md:col-span-6">
                            <h5 className="mb-1 block font-semibold">Provider</h5>
                            <select
                                name="Provider"
                                value={formData.Provider}
                                onChange={handleChange}
                                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
                            >
                                <option value="">Select Provider</option>
                                {ParentProviders.map((provider) => (
                                    <option key={provider._id} value={provider._id}>
                                        {provider.ProviderName}
                                    </option>
                                ))}
                            </select>
                            {errors.Provider && (
                                <p className="text-red-500 text-sm mt-1">{errors.Provider}</p>
                            )}
                        </div>

                        {/* Bill Type Input */}
                        <div className="col-span-12 lg:col-span-4 md:col-span-6">
                            <h5 className="mb-1 block font-semibold">Bill Type</h5>
                            <input
                                type="text"
                                name="BillType"
                                value={formData.BillType}
                                onChange={handleChange}
                                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
                            />
                            {errors.BillType && (
                                <p className="text-red-500 text-sm mt-1">
                                    {errors.BillType}
                                </p>
                            )}
                        </div>

                        {/* Api Type Input */}
                        <div className="col-span-12 lg:col-span-4 md:col-span-6">
                            <h5 className="mb-1 block font-semibold">Api Type</h5>
                            <input
                                type="text"
                                name="ApiType"
                                value={formData.ApiType}
                                onChange={handleChange}
                                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
                            />
                            {errors.ApiType && (
                                <p className="text-red-500 text-sm mt-1">
                                    {errors.ApiType}
                                </p>
                            )}
                        </div>

                        {/* Apis Input */}
                        <div className="col-span-12 lg:col-span-4 md:col-span-6">
                            <h5 className="mb-1 block font-semibold">Apis</h5>
                            <input
                                type="text"
                                name="Apis"
                                value={formData.Apis}
                                onChange={handleChange}
                                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
                            />
                            {errors.Apis && (
                                <p className="text-red-500 text-sm mt-1">{errors.Apis}</p>
                            )}
                        </div>

                        {/* Api Method Input */}
                        <div className="col-span-12 lg:col-span-4 md:col-span-6">
                            <h5 className="mb-1 block font-semibold">Api Method</h5>
                            <input
                                type="text"
                                name="ApiMethod"
                                value={formData.ApiMethod}
                                onChange={handleChange}
                                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
                            />
                            {errors.ApiMethod && (
                                <p className="text-red-500 text-sm mt-1">{errors.ApiMethod}</p>
                            )}
                        </div>

                        {/* Submit Button */}
                        <div className="submit_Form col-span-12 flex justify-center mt-3">
                            <button type="submit" className="All_button">
                                {editId ? "Update" : "Submit"}
                            </button>

                            {editId && (
                                <button
                                    type="button"
                                    className="bg-gray-500 text-white ms-2 px-4 py-2 rounded hover:bg-gray-600"
                                    onClick={() => {
                                        setFormData({
                                            Provider: "",
                                            BillType: "",
                                            ApiType: "",
                                            Apis: "",
                                            ApiMethod: "",
                                        });
                                        setEditId(null);
                                        setErrors({});
                                    }}
                                >
                                    Cancel
                                </button>
                            )}
                        </div>
                    </form>
                </div>

                <div className="px-2 py-6">
                    <div className="title">
                        <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block text-uppercase rounded">
                            View E-invoice & E-way Setup Detail
                        </h3>
                    </div>
                    <div className="rounded-lg overflow-x-auto mt-3">
                        <WpDynamicTable columns={columns} rows={rows} height="700px"/>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Einvoice_Eway_Setup_Detail;